<template>
  <div id="app">
    <header class="c header" v-show="$i18n.locale == 'zh'">
      <nav class="menu container clearfix">
        <a class="logo" href="./../index.html" title="hyperchain logo"></a>
        <div class="fr icon_open">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul>
          <li>
            <a class="link" href="./../index.html" title="超块链首页">
              <span>首页</span>
            </a>
          </li>
          <li>
            <a class="link" href="./chain.html" title="关于超块链">
              <span>超块链</span>
            </a>
            <div class="nav_div">
              <a class="link" href="./roadmap.html" title="超块链发展路线图">
                <span>路线图</span>
              </a>
              <a class="link" href="./Web3.html" title="Web3.0">
                <span>Web3.0</span>
              </a>
            </div>
          </li>
          <li>
            <a class="link" href="./product.html" title="产品服务">
              <span>产品服务</span>
            </a>
            <div class="nav_div">
              <a class="link" href="./NFT_Platform.html" title="数字确权一站式解决方案">
                <span>确权解决方案</span>
              </a>
              <a class="link" href="./solution.html" title="解决方案">
                <span>行业解决方案</span>
              </a>
              <a class="link" href="./community.html" title="成功案例">
                <span>成功案例</span>
              </a>
              <a class="link" href="./honor.html" title="资质荣誉">
                <span>资质荣誉</span>
              </a>
              <a class="link" href="./API_Purchase.html" title="数据API服务">
                <span>数据API服务</span>
              </a>
            </div>
          </li>
          <li>
            <a class="link active" href="hyperchainExplorer.html" title="超块链浏览器">
              <span>链浏览器</span>
            </a>
          </li>
          <li>
            <a class="link" href="http://www.hyperchain.net/blog/zh/" title="超块链博客">
              <span>博客</span>
            </a>
          </li>
          <li>
            <a class="link lang" href="javascript:;" @click="setLang('en')" title="Hyperchain Explorer">
              <span>English</span>
            </a>
          </li>
        </ul>
      </nav>
    </header>
    <div v-show="$i18n.locale != 'zh'" class="c header">
      <nav class="menu container clearfix">
        <a class="logo" href="./en/index.html"> </a>
        <div class="fr icon_open">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul>
          <li>
            <a class="link" href="./en/index.html" title="Hyperchain Homepage">
              <span>Home</span>
            </a>
          </li>
          <li>
            <a class="link" href="./en/chain.html" title="Hyperchain Technology">
              <span>Chain</span>
            </a>
            <a class="link" href="./en/roadmap.html" title="Hyperchain Product">
              <span>RoadMap</span>
            </a>
            <a class="link" href="./en/values.html" title="Hyperchain Technology">
              <span>Values</span>
            </a>
          </li>
          <li>
            <a class="link" href="./en/community.html" title="Success Case">
              <span>Case</span>
            </a>
            <a class="link" href="./en/honor.html" title="Honor">
              <span>Honor</span>
            </a>
          </li>
          <li>
            <a class="link active" href="hyperchainExplorer.html" title="Hyperchain Explorer">
              <span>Explorer</span>
            </a>
          </li>
          <li>
            <a class="link" href="http://www.hyperchain.net/blog" title="Hyperchain Blog">
              <span>Blog</span>
            </a>
          </li>
          <li>
            <a class="link lang" href="javascript:;" @click="setLang('zh')" title="超块链浏览器">
              <span>中文</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <router-view />
    <a href="#" class="backTop"></a>
    <footer class="footer" v-show="$i18n.locale == 'zh'">
      <div class="clearfix">
        <div class="fl">
          <div class="logo clearfix">
            <img class="img fl" src="@/../public/static/img/layout/logo.svg" alt="超块链" />
          </div>
          <ul class="clearfix ul">
            <li class="fl li">
              <a href="./roadmap.html" class="a" title="超块链发展路线图">路线图</a>
              <a href="./values.html" class="a" title="价值互联">价值互联</a>
            </li>
            <li class="fl li">
              <a href="./solution.html" class="a" title="解决方案">解决方案</a>
              <a href="./community.html" class="a" title="成功案例">成功案例</a>
              <a href="./honor.html" class="a" title="资质荣誉">资质荣誉</a>
            </li>
            <li class="fl li">
              <a href="./NFT_Platform.html" class="a" title="数字确权一站式方案">数字确权一站式方案</a>
              <a href="./Web3.html" class="a" title="探索Web3.0">探索Web3.0</a>
              <a href="./hyperchainExplorer.html#/BrowserHome?lang=zh&route=NFT" class="a" title="确权作品查询">确权作品查询</a>
              <a href="./API_Purchase.html" class="a" title="数据API服务">数据API服务</a>
            </li>
            <li class="fl li">
              <a href="./hyperchainExplorer.html#/BrowserHome?lang=zh" class="a" title="超块链浏览器">链浏览器</a>
              <a href="https://www.hyperchain.net/blog/?lang=zh" class="a" title="超块链博客">博客</a>
              <a href="./abouts.html" class="a" title="关于我们">关于我们</a>
            </li>
          </ul>
          <div class="icon_list clearfix">
            <a class="icon github" href="https://github.com/HyperBlockChain"> </a>
            <a class="icon weibo" href="https://weibo.com/6234080220"> </a>
            <a class="icon weixin" href="javascript:void(0);">
              <img class="qrcode" src="@/../public/static/img/layout/qrocde.jpg" alt="超块链公众号" />
            </a>
          </div>
        </div>
        <div class="fr">
          <h5 class="h5">联系我们 <img src="@/../public/static/img/home/down.png" alt="icon" class="drop" /></h5>
          <p class="p">
            <span v-if="dDenfTd2 == 0"
              >Email Loading...<span style="display: none"
                >hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com fLgeeMjJU@JpcsN.com fcolTVxFO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com
                HDBPwNBEFy@StH.com</span
              ></span
            >
            <a class="link" :href="'mailto:' + qnhZsHVpcSFR()" v-else
              ><span
                ><span style="display: none">hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com</span>hr<span style="display: none">fLgeeMjJU@Jpid</span>@hyperchain<span
                  style="display: none"
                >
                  N.com fcolTVx</span
                >.net<span style="display: none">FO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com HDBPwNBEFy@StH.com</span></span
              ></a
            >
          </p>
          <p class="p">
            <span v-if="dDenfTd3 == 0"
              >Email Loading...<span style="display: none"
                >hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com fLgeeMjJU@JpidN.com fcolTVxFO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com
                HDBPwNBEFy@StH.com</span
              ></span
            >
            <a class="link" :href="'mailto:' + qnhZsHVpcSFR1()" v-else
              ><span
                ><span style="display: none">hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com</span>biz<span style="display: none">fLgeeMjJU@Jpid</span>@hyperchain<span
                  style="display: none"
                >
                  N.com fcolTVx</span
                >.net<span style="display: none">FO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com HDBPwNBEFy@StH.com</span></span
              ></a
            >
          </p>

          <h5 class="h5">公司地址 <img src="@/../public/static/img/home/down.png" alt="icon" class="drop" /></h5>
          <p class="p">北京：海淀区中关村西区善缘街1号立方庭2-303</p>
          <p class="p">苏州：苏州工业园区星湖街328号创意产业园2-A309</p>
        </div>
      </div>
      <div class="copyright tc"></div>
    </footer>
    <!-- <div class="footer" v-show="$i18n.locale == 'zh'">
      <div class="contact">
        <ul class="container clearfix">
          <li>
            <h5 class="h5">关于我们 <img src="@/../public/static/img/home/down.png" alt="icon" class="drop"></h5>
            <p><a class="link" href="https://www.hyperchain.net/blog/?lang=zh" title="博客">博客</a></p>
            <p><a class="link" href="./abouts.html" title="关于我们">关于我们</a></p>
          </li>
          <li>
            <h5 class="h5">联系我们 <img src="@/../public/static/img/home/down.png" alt="icon" class="drop"></h5>
            <p>
              <span v-if="dDenfTd2 == 0">Email Loading...<span style=display:none;>hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com fLgeeMjJU@JpcsN.com fcolTVxFO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com HDBPwNBEFy@StH.com</span></span>
              <a :href="'mailto:' + qnhZsHVpcSFR()" v-else><span><span style="display:none;">hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com</span>hr<span style="display:none;">fLgeeMjJU@Jpid</span>@hyperchain<span style="display:none;"> N.com fcolTVx</span>.net<span style="display:none;">FO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com HDBPwNBEFy@StH.com</span></span></a>
            </p>
            <p>
              <span v-if="dDenfTd3 == 0">Email Loading...<span style=display:none;>hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com fLgeeMjJU@JpidN.com fcolTVxFO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com HDBPwNBEFy@StH.com</span></span>
              <a :href="'mailto:' + qnhZsHVpcSFR1()" v-else><span><span style="display:none;">hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com</span>biz<span style="display:none;">fLgeeMjJU@Jpid</span>@hyperchain<span style="display:none;"> N.com fcolTVx</span>.net<span style="display:none;">FO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com HDBPwNBEFy@StH.com</span></span></a>
            </p>
          </li>
          <li>
            <h5 class="h5">公司地址 <img src="@/../public/static/img/home/down.png" alt="icon" class="drop"></h5>
            <p>北京：海淀区中关村西区善缘街1号立方庭2-303</p>
            <p>苏州：苏州工业园区星湖街328号创意产业园2-A309</p>
          </li>
        </ul>
      </div>
      <div class="copyright c">
          <p class="container">
            ©2016 - 2018 Copy Right Reserved <span class="s_phone">Hyperchain Inc<br/></span> 
            <span class="s_pc">苏州超块链信息科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;</span> 苏ICP备17039971号&nbsp;&nbsp;&nbsp;&nbsp;苏公网安备 32059002001577号</p>
      </div>
    </div> -->
    <div class="en_footer" v-show="$i18n.locale != 'zh'">
      <div class="contact">
        <ul class="container clearfix">
          <li>
            <h5 class="h5">About Us <img src="@/../public/static/img/home/down.png" alt="icon" class="drop" /></h5>
            <p><a class="link" href="https://www.hyperchain.net/blog/?lang=en" title="Blog">Blog</a></p>
            <p><a class="link" href="./en/abouts.html" title="Abouts Us">Abouts Us</a></p>
          </li>
          <li>
            <h5 class="h5">Contact Us <img src="@/../public/static/img/home/down.png" alt="icon" class="drop" /></h5>
            <p class="p">
              <span v-if="dDenfTd2 == 0"
                >Email Loading...<span style="display: none"
                  >hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com fLgeeMjJU@JpidN.com fcolTVxFO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com
                  HDBPwNBEFy@StH.com</span
                ></span
              >
              <a class="link" :href="'mailto:' + qnhZsHVpcSFR()" v-else
                ><span
                  ><span style="display: none">hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com</span>hr<span style="display: none">fLgeeMjJU@Jpid</span>@hyperchain<span
                    style="display: none"
                  >
                    N.com fcolTVx</span
                  >.net<span style="display: none">FO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com HDBPwNBEFy@StH.com</span></span
                ></a
              >
            </p>
            <p class="p">
              <span v-if="dDenfTd3 == 0"
                >Email Loading...<span style="display: none"
                  >hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com fLgeeMjJU@JpidN.com fcolTVxFO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com
                  HDBPwNBEFy@StH.com</span
                ></span
              >
              <a class="link" :href="'mailto:' + qnhZsHVpcSFR1()" v-else
                ><span
                  ><span style="display: none">hnNijkJXGJ@NDRne.com LkZMyrcXu@tdc.com SMDNEJY@OfGMzE.com hqzhLDb@pflu.com</span>biz<span style="display: none">fLgeeMjJU@Jpid</span>@hyperchain<span
                    style="display: none"
                  >
                    N.com fcolTVx</span
                  >.net<span style="display: none">FO@ErMKTkv.com Uktju@EeX.com yPEkqnvkWm@eyQLVp.com WRzOBoH@WCniwF.com HDBPwNBEFy@StH.com</span></span
                ></a
              >
            </p>
          </li>
          <li>
            <h5 class="h5">Social Media <img src="@/../public/static/img/home/down.png" alt="icon" class="drop" /></h5>
            <div class="fa_list">
              <p class="fa_p">
                <a class="fa fa-facebook-square" href="https://www.facebook.com/Hyper-Block-Chain-1601553016543512/?ref=aymt_homepage_panel" title="Hyperchain Facebook"> </a>
                <span>Facebook</span>
              </p>
              <p class="fa_p">
                <a class="fa fa-twitter" href="https://twitter.com/DevHyperchain" title="Hyperchain Twitter"> </a>
                <span>Twitter</span>
              </p>
              <p class="fa_p">
                <a class="fa fa-blog" href="https://www.hyperchain.net/blog/" title="Hyperchain Blog"> </a>
                <span>Blog</span>
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div class="copyright c">
        <p class="container">
          ©2016 - 2018 Copy Right Reserved <span class="s_phone">Hyperchain Inc<br /></span>
          <span class="s_pc">苏州超块链信息科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;</span> 苏ICP备17039971号&nbsp;&nbsp;&nbsp;&nbsp;苏公网安备 32059002001577号
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#app {
  & > div:nth-child(3) {
    min-height: calc(100vh - 351px);
  }
}
</style>
<script>
export default {
  data() {
    return {
      dDenfTd2: 0,
      dDenfTd3: 0,
    }
  },
  created() {
    setTimeout(() => {
      this.dDenfTd2 = 1
      this.dDenfTd3 = 1
    }, 3000)
    this.lang()
  },
  watch: {
    $route() {
      this.lang()
    },
  },
  methods: {
    lang() {
      var lang = this.$route.query.lang
      if (lang) {
        this.$i18n.locale = lang
        localStorage.setItem('language', lang)
        this.$router.push('/')
      } else if (localStorage.getItem('language')) {
        this.$i18n.locale = localStorage.getItem('language')
      }
    },
    setLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('language', lang)

      if (this.$route.name === 'Node_map') {
        this.$router.go(0)
      }
    },
    qnhZsHVpcSFR() {
      var lquEAvWd = 'LJcsmze',
        UizhxYzCZ = '@IqyLGb.com',
        dDenfTd2 = 'hr',
        jTdBFdsN = '@hyperchain.net',
        BgCIjr = 'olrwozA',
        rQSKOrR = '@aonB.com',
        AVIJSoK = 'ZaJjmEc',
        zvlrw = '@DFYx.com'
      return dDenfTd2 + jTdBFdsN
    },
    qnhZsHVpcSFR1() {
      var lquEAvWd = 'LJcsmze',
        UizhxYzCZ = '@IqyLGb.com',
        dDenfTd3 = 'biz',
        jTdBFdsN = '@hyperchain.net',
        BgCIjr = 'olrwozA',
        rQSKOrR = '@aonB.com',
        AVIJSoK = 'ZaJjmEc',
        zvlrw = '@DFYx.com'
      return dDenfTd3 + jTdBFdsN
    },
  },
}
</script>

<style lang="scss">
.backTop {
  position: fixed;
  top: 90%;
  right: 10px;
  z-index: 99;
  padding: 20px;
  background-color: #eee;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);

  // &:hover {
  //   color: #ffe276;
  // }

  &:hover:before {
    border-color: #4b5666 #4b5666 transparent transparent;
  }

  &:hover:after {
    background-color: #4b5666;
  }

  &:before {
    content: '';
    position: absolute;
    top: 14px;
    left: 50%;
    z-index: 0;
    transform: translateX(-50%) rotate(-45deg);
    width: 12px;
    height: 12px;
    border-width: 1px;
    border-style: solid;
    border-color: #4b5666 #4b5666 transparent transparent;
  }

  &:after {
    content: '';
    position: absolute;
    top: 24px;
    left: 50%;
    z-index: 0;
    transform: translateX(-50%);
    width: 14px;
    height: 1px;
    background-color: #4b5666;
  }
}
</style>
